import React, { } from "react";
import GridStore from "./grid.store";
import { observer } from "mobx-react-lite";

const store = new GridStore();

const GridDataContext = React.createContext(new GridStore());

export const GridDataContextProvider = observer((props: any) => {
  return (
    <GridDataContext.Provider value={store}>
      {props.children}
    </GridDataContext.Provider>
  );
});

export default GridDataContext;
